export default __webpack_public_path__ + "015fffd550c150524161fe34bdca01c4.png";